import { TipoClasse } from './tipo-classe.model';
import { ProjetoTipoClasse } from './projeto-tipo-classe.model';
import { Alcance } from './alcance.model';
import { AnoBase } from './ano-base.model';
import { Artigo } from './artigo.model';
import { ComplementoProjeto } from './complemento-projeto.model';
import { ProjetoPropriedadeIntelectual } from './projeto-propriedade-intelectual.model';
import { Projeto } from './projeto.model';
import { ResponsavelProjeto } from './responsavel-projeto.model';
import { TipoProjeto } from './tipo-projeto.model';

export class InformacoesProjetoVO {

  projeto: Projeto;
  responsavelProjeto: ResponsavelProjeto;
  alcances: Alcance[];
  complementoProjeto: ComplementoProjeto;
  artigos: Artigo[];
  anoBase: AnoBase;
  tipoProjeto: TipoProjeto;
  projetoTipoClasse: ProjetoTipoClasse;
  classe: TipoClasse;
  propriedadesIntelectuais: ProjetoPropriedadeIntelectual[];

  constructor(init?: Partial<InformacoesProjetoVO>) {
      Object.assign(this, init);
  }
}
